import { Button as BaseButton } from "@base-ui/react/button";
import { cn } from "./cn";

export type ButtonVariant = "primary" | "secondary" | "ghost" | "danger";
export type ButtonSize = "sm" | "md";

const base =
    "inline-flex items-center justify-center gap-2 rounded-md font-medium " +
    "border transition-colors cursor-pointer select-none " +
    "focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent " +
    "disabled:opacity-50 disabled:cursor-not-allowed";

const variants: Record<ButtonVariant, string> = {
    primary:
        "bg-accent text-accent-fg border-accent hover:brightness-95 active:brightness-90",
    secondary:
        "bg-surface text-fg border-border hover:bg-bg active:bg-border/40",
    ghost:
        "bg-transparent text-fg border-transparent hover:bg-border/40",
    danger:
        "bg-red-600 text-white border-red-600 hover:bg-red-700 active:bg-red-800",
};

const sizes: Record<ButtonSize, string> = {
    sm: "h-8 px-2.5 text-xs",
    md: "h-9 px-3 text-sm",
};

export type ButtonProps = React.ComponentPropsWithoutRef<"button"> & {
    variant?: ButtonVariant;
    size?: ButtonSize;
};

/** Themed button built on Base UI's accessible button primitive. */
export function Button({
    variant = "secondary",
    size = "md",
    className,
    ...props
}: ButtonProps) {
    return (
        <BaseButton
            className={cn(base, variants[variant], sizes[size], className as string)}
            {...props}
        />
    );
}
